"use strict";
exports.__esModule = true;
exports.kebabize = void 0;
var kebabize = function (value) {
    return value === null || value === void 0 ? void 0 : value.replace(/[A-Z]/g, function (str, i) { return "" + ((i && '-') || '') + str; }).toLowerCase();
};
exports.kebabize = kebabize;
//# sourceMappingURL=kebabize.js.map